import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-2 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    rounded: "xl",
    class: "p-3"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_LpInput, {
          modelValue: _ctx.displayAmount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayAmount = $event)),
          type: "text",
          prefix: _ctx.currencyPrefix,
          placeholder: _ctx.$t('codIncome.withdrawal.amountPlaceholder'),
          format: _ctx.formatValue,
          disabled: _ctx.disabled,
          error: !!_ctx.errorMessage,
          "error-caption": _ctx.errorMessage,
          "error-icon": true
        }, null, 8, ["modelValue", "prefix", "placeholder", "format", "disabled", "error", "error-caption"])
      ])
    ]),
    _: 1
  }))
}